import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { deleteFee } from '../../API';
import { getCurrency, getShortDate, toggleOptionsMenu } from '../../Helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIndustry, faHashtag, faDollarSign, faCheckSquare, faEllipsisH, faEdit, faEye, faUsers, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { faSquare, faCalendar, faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import YesNoModal from '../YesNoModal';

function FeeCard(props) {
    const [deletionConfirmationModal, setDeletionConfirmationModal] = useState(false);

    const toggleDeletionConfirmationModal = () => setDeletionConfirmationModal(!deletionConfirmationModal);

    const paidInFull = props.fee.isPaidInFull ? "Paid" : "Unpaid";
    const paidInFullIcon = props.fee.isPaidInFull ? (<FontAwesomeIcon icon={faCheckSquare} />) : (<FontAwesomeIcon icon={faSquare} />);

    const viewURL = '/admin/fees/' + props.fee.feeID;
    const editURL = '/admin/fees/' + props.fee.feeID + '/edit';

    return (
        <div className="card item-details">
            <div className="properties">
                <div className="svg-label tooltip-parent">
                    {paidInFullIcon}
                    <span>{paidInFull}</span>
                    <div className="tooltip-target">
                        Paid In Full
                    </div>
                </div>
                <div className="svg-label tooltip-parent">
                    <i className="fas fa-asterisk"></i>
                    <span>{props.fee.account.accountNumber}</span>
                    <div className="tooltip-target">
                        Account Number
                        </div>
                </div>
                <div className="svg-label tooltip-parent">
                    <i className="fas fa-city"></i>
                    <span>{props.fee.account.name}</span>
                    <div className="tooltip-target">
                        Account
                        </div>
                </div>
                <div className="svg-label tooltip-parent">
                    <FontAwesomeIcon icon={faUsers} />
                    <span>{props.fee.division?.divisionName}</span>
                    <div className="tooltip-target">
                        DANR Program
                    </div>
                </div>
                <div className="svg-label tooltip-parent">
                    <FontAwesomeIcon icon={faIndustry} />
                    <span>{props.fee.facility}</span>
                    <div className="tooltip-target">
                        Facililty
                    </div>
                </div>
                <div className="svg-label tooltip-parent">
                    <FontAwesomeIcon icon={faHashtag} />
                    <span>{props.fee.identifier}</span>
                    <div className="tooltip-target">
                        EPA ID/Permit Number
                    </div>
                </div>
                <div className="svg-label tooltip-parent">
                    <FontAwesomeIcon icon={faFileAlt} />
                    <span>{props.fee.feeDescription}</span>
                    <div className="tooltip-target">
                        Description
                    </div>
                </div>
                <div className="svg-label tooltip-parent">
                    <FontAwesomeIcon icon={faCalendar} />
                    <span>{props.fee.fiscalYear}</span>
                    <div className="tooltip-target">
                        Fiscal Year
                    </div>
                </div>
                <div className="svg-label tooltip-parent">
                    <FontAwesomeIcon icon={faDollarSign} />
                    <span>{getCurrency(props.fee.currentBalance)} / {getCurrency(props.fee.feeAmount)}</span>
                    <div className="tooltip-target">
                        Amount Balance/Total
                    </div>
                </div>
                <div className="svg-label tooltip-parent">
                    <FontAwesomeIcon icon={faCalendarAlt} />
                    <span>{getShortDate(props.fee.dueDate)}</span>
                    <div className="tooltip-target">
                        Due Date
                    </div>
                </div>
            </div>
            <div className="actions">
                <Link to={viewURL} className="action-icon action-view">
                    <FontAwesomeIcon icon={faEye} />
                </Link>
                {window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                    <Link to={editURL} className="action-icon action-edit">
                        <FontAwesomeIcon icon={faEdit} />
                    </Link>
                ) : null}
                <div onClick={toggleOptionsMenu} className="action-icon action-dropdown">
                    <FontAwesomeIcon icon={faEllipsisH} />
                    <div className="action-dropdown-menu">
                        <Link className="action-dropdown-menu-item" to={`/admin/accounts/${props.fee.accountID}`}>View Account</Link>
                        {window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                            <div className="action-dropdown-menu-item" onClick={toggleDeletionConfirmationModal}><span>Delete</span></div>
                        ) : null}
                    </div>
                </div>
            </div>
            <YesNoModal title="Confirm Deletion" yesClick={async () => await props.deleteRecord()} open={deletionConfirmationModal} toggle={toggleDeletionConfirmationModal}>Are you sure you want delete this Fee?</YesNoModal>
        </div>
    );
}

export default FeeCard;